enum RmaConditionsOnReceiptEnum {
    GOOD = 1,
    DAMAGED = 2,
    UNUSABLE = 3,
    NOT_RECEIVED = 4,
}

export default RmaConditionsOnReceiptEnum;
